// src/ui/WelcomePane.jsx — what fills the right-hand side when no chat is open.
//
// This is the largest single surface in the app and it used to hold a 76px square with
// the letter "A" in it. It's the first thing you see after pairing and every time you
// close a conversation, so it gets the real treatment: the same theme-aware chat mark
// the sidebar uses, played once at hero size over a soft glow, and three quiet lines
// about what this client actually does — which doubles as an answer to the question a
// blank pane always raises, "is it connected to my phone or not?".

import React from 'react';
import BrandLottie from './BrandLottie';
import { Lock, Phone, Paperclip } from './icons';

const POINTS = [
  {
    Icon: Lock,
    title: 'End-to-end encrypted',
    body: 'Messages are sealed to your devices. Nobody in between — not even Allo — can read them.',
  },
  {
    Icon: Phone,
    title: 'In step with your phone',
    body: 'History, receipts, unread counts and pins stay the same on both, whichever one you pick up.',
  },
  {
    Icon: Paperclip,
    title: 'Everything you send there',
    body: 'Photos, videos, voice notes, documents, locations, polls and flight cards — all from the keyboard.',
  },
];

export default function WelcomePane() {
  return (
    <div className="allo-chat">
      <div className="welcome">
        <div className="wc-hero">
          <span className="wc-glow" aria-hidden="true" />
          {/* `bare` drops the negative margins that tuck this into the sidebar header;
              loop={false} means it plays exactly once each time the pane is shown */}
          <BrandLottie size={190} bare />
        </div>

        <h1 className="wc-title">Allo for Web</h1>
        <p className="wc-sub">
          Select a chat to start messaging. Your conversations stay end-to-end encrypted
          and sync with your phone.
        </p>

        <div className="wc-points">
          {POINTS.map(({ Icon, title, body }) => (
            <div className="wc-card" key={title}>
              <span className="wc-ico"><Icon width={19} height={19} /></span>
              <div className="wc-card-t">{title}</div>
              <div className="wc-card-b">{body}</div>
            </div>
          ))}
        </div>

        <div className="wc-foot">
          <Lock /> <span>Your messages are end-to-end encrypted</span>
        </div>
      </div>
    </div>
  );
}
